<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">宠物类别<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>宠物类别</label>
              <el-select v-model="petType" placeholder="Select" class="select-item" @change="petTypeChange">
                <el-option v-for="item in petTypeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>品种</label>
              <el-select v-model="petId" placeholder="Select" class="select-item">
                <el-option v-for="item in petIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
              <!--            <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
            </div>
          </div>


        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="editPetDialog(-1)" size="default">添加品种</el-button>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="name" label="宠物类别" v-if="checkColList.indexOf('宠物类别') > -1" width="120">
              <template #default="scope">
                {{scope.row.type == 1?'猫':scope.row.type == 2?'狗':''}}
              </template>
            </el-table-column>
            <el-table-column property="name" label="品种" v-if="checkColList.indexOf('品种') > -1" width="120"/>
            <el-table-column property="" label="头像" v-if="checkColList.indexOf('头像') > -1" width="120">
              <template #default="scope">
                <div v-if="scope.row.headImg" class="cursor" @click="showImg(scope.row.headImg)">
                  <el-image class="item-img" fit="cover" :src="scope.row.smallHeadImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
                <div v-else>
                  <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="" label="花色" v-if="checkColList.indexOf('花色') > -1">
              <template #default="scope">
<!--                <el-space wrap>-->
<!--                  <el-tag v-for="item of scope.row.petBreedColorList" :key="item.id">{{ item.name }}</el-tag>-->
<!--                </el-space>-->
                  <div v-for="(item,index) of scope.row.petBreedColorList" :key="item.id" style="margin: 4px; float: left">
                    <el-tag effect="plain" type="info" size="large" v-show="!item.show" closable  @click="inputBreed(item, index, scope.$index)" @close="delBreed(index, item, scope.$index)" class="cursor">{{ item.name }}</el-tag>
                    <el-input :ref="'inputRef' + scope.$index" v-show="item.show"  type="text" v-model="item.name" style="width: 6em" @blur="breedChange(item)"/>
                  </div>
              </template>
            </el-table-column>
            <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1" width="120"/>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1" width="200">
              <template #default="scope">
                <el-button @click="editPetDialog(scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
                <el-button @click="delCategory(scope.$index,scope.row)" size="small" type="danger">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getPetPageList, getAllPetBreedList, delPetBreed, updatePetBreedColor, delPetBreedColor} from "@/api/url";
import PetDialog from "./components/PetDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "Pet",
  components: { BtnGroup, SearchComponents, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      petIdArray: [
        {name: '不限', id: 0},
      ],
      petId: 0,

      allPetIdList: [],

      petTypeArray: [
        {label: '不限', value: -1},
        {label: '猫', value: 1},
        {label: '狗', value: 2}
      ],
      petType: -1,

      //刷新组
      colList: ['宠物类别', '品种', '头像', '花色', '排序', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '品种', value : 1},
      ],
      searchType: 1,
      searchValue: '',

    }
  },
  methods: {

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList,
        imgIndex: 0
      })
    },


    inputBreed(item, idx, index) {
      this.pageDataList.forEach(item => {
        item.petBreedColorList.map(e => {
          e.show = false
        })
      })
      item.show = true
      // console.log(this.$refs)
      this.$refs['inputRef' + index][idx].focus()
    },

    breedChange(item) {
      if(!item.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入花色名称',
          type: 'warning'
        });
        item.name = item.oldName
        return false
      }
      let param = {}
      param['id'] = item.id;
      param['name'] = item.name;
      param['type'] = 1;
      postFormData(updatePetBreedColor, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          item.show = false
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    delBreed(idx, item, index) {
      this.$confirm('确认删除花色【' + item.name + '】？').then(() => {
        let param = {}
        param['id'] = item.id;
        param['name'] = item.name;
        param['type'] = 2;
        postFormData(delPetBreedColor, param).then((data) => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.pageDataList[index].petBreedColorList.splice(idx, 1)
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
        })
      })

    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['id'] = this.petId;
      param['type'] = this.petType;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getPetPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result.records;
          for(let i=0; i<this.pageDataList.length; i++) {
            if(this.pageDataList[i].petBreedColorList.length > 0) {
              this.pageDataList[i].petBreedColorList.forEach(item => {
                item.show = false
                item.oldName = item.name
              })
            }
          }
          // console.log(this.pageDataList)
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editPetDialog(idx, row) {
      let _title = '';
      let petForm = {}
      if (idx > -1) {
        _title = '编辑品种'
        petForm = Object.assign({}, row);
        // console.log(petForm)
      }else {
        _title = '添加品种'
        // console.log(petForm)
      }
      Dialog.open({
        title: _title,
        component: PetDialog,
        data: {
          petForm: petForm,
          ids: idx,
          width: '500px',
        },
        confirm: (result) => {
          this.getPage()
          this.getCategoryList()
        },
        // close: (result) => {
        //   if(idx > -1) {
        //     this.getPage()
        //   }
        // }
      })
    },


    // getShopList() {
    //   getFormData(getAllShopList).then(data=> {
    //     data.data.map((item) => {
    //       if(item.id != 0) {
    //         this.shopIdArr.push(item)
    //       }
    //       this.shopIdArray = this.shopIdArray.concat(this.shopIdArr)
    //     })
    //   })
    // }


    delCategory(idx, row) {
      this.$confirm('确认删除品种【' + row.name + '】？').then(() => {
        row.updateLoading = true;
        let param = {};
        param['id'] = row.id;
        postFormData(delPetBreed, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList.splice(idx, 1)
            this.getCategoryList()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.updateLoading = false;
        }).catch(()=> {
          row.updateLoading = false;
        })
      })
    },

    getCategoryList() {
      getFormData(getAllPetBreedList).then(data => {
        this.allPetIdList = data.data
        this.petIdArray = [{name: '不限', id: 0}]
        this.petIdArray = this.petIdArray.concat(this.allPetIdList)
      })
    },

    petTypeChange(val) {
      this.petIdArray = [{name: '不限', id: 0}]
      this.petId = 0
      if(val > -1) {
        let list = this.allPetIdList.filter(item => item.type == val)
        this.petIdArray = this.petIdArray.concat(list)
      }else {
        this.petIdArray = this.petIdArray.concat(this.allPetIdList)
      }
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getCategoryList()
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 80px;
  height: 80px;
}
</style>
